/**
 * Configuración centralizada de la aplicación
 *
 * Único archivo que accede a process.env
 */

// ============================================================
// API Configuration
// ============================================================

export const API_CONFIG = {
  DC_BASE_URL:
    process.env.REACT_APP_DC_API_URL ||
    'https://p59f36qunl.execute-api.us-east-1.amazonaws.com/dc/api',

  SSCN_API_URL: process.env.REACT_APP_SSCN_API_URL || '',
  API_ENP: process.env.REACT_APP_API_ENP || '',
  BUCKET_NAME: process.env.REACT_APP_BUCKETNAME || '',
};

// ============================================================
// Auth Configuration
// ============================================================

export const AUTH_CONFIG = {
  /**
   * Modo de autenticación:
   * - 'dev'   -> autenticación local mediante credenciales de desarrollo
   * - 'auth0' -> autenticación mediante Auth0
   *
   * Si REACT_APP_AUTH_MODE no existe, el valor por defecto es 'auth0'.
   */
  MODE: process.env.REACT_APP_AUTH_MODE === 'dev' ? 'dev' : 'auth0',
  // Credenciales para modo dev
  DEV: {
    API_KEY: process.env.REACT_APP_DEV_API_KEY || '',

    USER: {
      sub: process.env.REACT_APP_DEV_USER_SUB || 'dev-user',

      email:
        process.env.REACT_APP_DEV_USER_EMAIL ||
        'dev@aeromexico.com',

      name:
        process.env.REACT_APP_DEV_USER_NAME ||
        'Usuario Desarrollo',

      nickname:
        process.env.REACT_APP_DEV_USER_NICKNAME ||
        'DEV_USER',
    },
  },

  // Configuración Auth0
  AUTH0: {
    DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN || '',

    CLIENT_ID:
      process.env.REACT_APP_AUTH0_CLIENTID || '',

    AUDIENCE:
      process.env.REACT_APP_AUTH0_AUDIENCE || '',
  },
};

// ============================================================
// Convenience exports
// ============================================================

export const DEV_MODE = AUTH_CONFIG.MODE === 'dev';
export const DEV_API_KEY = AUTH_CONFIG.DEV.API_KEY;
export const DEV_USER = AUTH_CONFIG.DEV.USER;
export const AUTH0_CONFIG = AUTH_CONFIG.AUTH0;